import React, { ReactElement } from "react";
import sanitizeHtml from "sanitize-html";

export interface HtmlRendererProps {
    className?: string;
    html: string;
}

const ALLOWED_TAGS = [
    "address", "article", "aside", "footer", "header", "h1", "h2", "h3", "h4",
    "h5", "h6", "hgroup", "main", "nav", "section", "blockquote", "dd", "div",
    "dl", "dt", "figcaption", "figure", "hr", "li", "main", "ol", "p", "pre",
    "ul", "a", "abbr", "b", "bdi", "bdo", "br", "cite", "code", "data", "dfn",
    "em", "i", "kbd", "mark", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp",
    "small", "span", "strong", "sub", "sup", "time", "u", "var", "wbr", "caption",
    "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead", "tr",
    "mention",
];

export function HtmlRenderer(props: HtmlRendererProps): ReactElement {
    const htmlBody = sanitizeHtml(props.html, {
        allowedTags: ALLOWED_TAGS,
        allowedAttributes: {
            // eslint-disable-next-line id-length
            a: ["href", "name", "target"],
            mention: ["data-id"],
            img: ["src"],
        },
        transformTags: {
            // eslint-disable-next-line id-length
            a: (__tagName, attributes) => ({
                tagName: "a",
                attribs: {
                    ...attributes,
                    target: "_blank",
                    rel: "noreferrer noopener",
                },
            }),
        },
    });
    return (
        // eslint-disable-next-line react/no-danger
        <div className={props.className} dangerouslySetInnerHTML={{ __html: htmlBody }} />
    );
}

HtmlRenderer.defaultProps = {
    className: "",
};
